import { Link } from "react-router-dom";
import LogoMark from "../images/LogoMark";
import Button from "../ui/Button";
import ThemeToggle from "../ui/ThemeToggle";
import "./Nav.css";

export default function Nav() {
  return (
    <header className="nav">
      <div className="nav__inner">
        <Link to="/" className="nav__brand">
          <LogoMark size={26} />
          <span>Eolass</span>
        </Link>

        <div className="nav__actions">
          <ThemeToggle />
          <Button to="/login" variant="primary" size="md" className="nav__cta">
            Try Eolass
          </Button>
        </div>
      </div>
    </header>
  );
}
